// src/blocks/HeroBannerBlock/HeroBannerBlock.component.tsx
import React, { Children } from 'react';
import clsx from 'clsx';

import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';
import Button from '@/elements/Button/Button.component';

import { IProps } from '@/blocks/HeroBannerBlock/HeroBannerBlock.interface';
import '@/blocks/HeroBannerBlock/HeroBannerBlock.styles.css';
import Icon from '@/elements/Icon/Icon.component';

export const HeroBannerBlock: React.FC<IProps> = ({
    backButton,
    title,
    description,
    buttons,
    className,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper
            className={clsx('heroBannerBlock', className)}
            {...blockWrapperProps}
            layout="hero"
        >
            <ContentWrapper>
                <ContentColumn layout="two-thirds">
                    {backButton && (
                        <Button
                            {...backButton}
                            icon='chevron-left'
                            iconPosition='before'
                            size="sm"
                            className="heroBannerBlock__backButton"
                        />
                    )}
                    {title && (
                        <Heading level={1} className="heroBannerBlock__title" html={title} />
                    )}
                    {description && (
                        <Text className="heroBannerBlock__description" html={description} />
                    )}
                    {buttons && buttons.length > 0 && (
                        <div className="heroBannerBlock__buttons">
                            {buttons.map((btn, idx) => (
                                <Button
                                    key={`hero-banner-block-cta-${idx}`}
                                    {...btn}
                                    className="heroBannerBlock__button"
                                />
                            ))}
                        </div>
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export default HeroBannerBlock;
